import { useState } from 'react';

import API from 'service/api';
import Util, { Data } from 'service/util';

import PopMessage from './pop-msg/PopMessage';

const ConfirmAddVehicleModal = ({onConfirm, onCancel, customers, ...props}) =>
{

  return (<>
    <p className="message red">車輛已經被其他客戶註冊，是否仍要繼續為此客戶建新車輛？</p>
    <table className="data-table">
      <thead>
        <tr>
          <th>客戶編號</th>
          <th>登入名稱</th>
          <th>顯示名稱</th>
          <th>建立日期</th>
          <th>修改日期</th>
        </tr>
      </thead>
      <tbody>
        { customers.map(x =>
          <tr key={x.id}>
            <td>{ x.id }</td>
            <td>{ x.login_name }</td>
            <td>{ x.display_name }</td>
            <td>{ Util.FullDate(x.create_dtm) }</td>
            <td>{ Util.FullDate(x.mod_dtm) }</td>
          </tr>
        )}
      </tbody>
    </table>
    <div className="action-panel">
      <button className="btn grey" onClick={onCancel}>取消</button>
      <button className="btn red" onClick={onConfirm}>確定建立</button>
    </div>
  </>);
}

const AddVehicleModal = ({owner, ...props}) =>
{
  const [license, setLicense]     = useState('');
  const [vh_type, setVehicleType] = useState(1);
  const [source, setSource]       = useState(0);
  const [color, setColor]         = useState('');
  const [brand, setBrand]         = useState('');
  const [model, setModel]         = useState('');
  const [remarks, setRemarks]     = useState('');

  const [customers, setCustomers] = useState(null);

  const getDto = () =>
  {
    return ({
      owner_id: owner.id
     ,cd_license: String(license||'').trim().toUpperCase()
     ,vh_type, source, color, brand, model, remarks
   });
  }

  const addVehicle = (force) =>
  {
    let vehicleDto = getDto();
    if (force) { vehicleDto.force = true; }

    API.addVehicle(vehicleDto).then( resp => {
      if (!resp.success)
      {
        PopMessage.show('車輛已存在。', '新增失敗', 'danger');
        setCustomers(resp.msg);
      }
      else
      {
        let rtn_vehicle = resp.msg;
        if (!rtn_vehicle.services) rtn_vehicle.services = [];
        owner.vehicles.push(rtn_vehicle);
        props.onClose();
        PopMessage.show('已成功新增車輛。', '成功', 'success');
      }
    });
  }

  // Confirm
  if (customers)
  {
    return <ConfirmAddVehicleModal customers={customers} onConfirm={e=>addVehicle(true)} onCancel={e=>setCustomers(null)} />
  }

  return (<>
    <label className="field">
      <strong>車牌號碼</strong>
      <input type="text" placeholder="新車車牌號碼" value={license}
             onChange={e=>setLicense(e.target.value.trim().toUpperCase())}
             onBlur={e=>setLicense(e.target.value.replace(' ', '').toUpperCase())}
             />
    </label>
    <label className="field">
      <strong>車輛總類</strong>
      <select value={vh_type} onChange={e=>setVehicleType(parseInt(e.target.value, 10))}>
        { Data.vtype.map(vt =>
          <option key={`vhtype-${vt.id}`} value={vt.id}>{ vt.id} - { vt.desc }</option>
        )}
      </select>
    </label>
    <label className="field">
      <strong>客戶來源</strong>
      <select value={source} onChange={e=>setSource( parseInt(e.target.value,10) )}>
        <option value={0}></option>
        <option value={1}>傳單</option>
        <option value={2}>工人介紹</option>
        <option value={3}>優悠家居</option>
        <option value={4}>合拼</option>
      </select>
    </label>
    <label className="field">
      <strong>顏色</strong>
      <input type="text" value={color} onChange={e=>setColor(e.target.value)} />
    </label>
    <label className="field">
      <strong>品牌</strong>
      <input type="text" value={brand} list="ls-brand"
        onChange={e=>setBrand(e.target.value)} />
      <datalist id="ls-brand">
        { Data.brand.map(b =>
          <option key={`brand-${b.name_en}`} value={b.name_en}>{b.name_zh}</option>
        )}
      </datalist>
    </label>
    <label className="field">
      <strong>型號</strong>
      <input type="text" value={model} onChange={e=>setModel(e.target.value)} />
    </label>
    <label className="field">
      <strong>備註</strong>
      <textarea value={remarks||''}
        onChange={e=>setRemarks(e.target.value)}
        onblur={e=>setRemarks(e.target.value.trim()||null)}>
      </textarea>
    </label>
    <div className="action-panel">
      <div className="dummy"></div>
      <button type="button" className="btn blue" onClick={e=>addVehicle()}>新增</button>
    </div>
  </>);
}

export default AddVehicleModal